import React from 'react';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Checkbox from '@material-ui/core/Checkbox';
import Typography from '@material-ui/core/Typography';
import {makeStyles} from "@material-ui/core/styles";
import { useTheme } from '@material-ui/core/styles';
import { fade } from '@material-ui/core';

import 'date-fns';
import DateFnsUtils from '@date-io/date-fns';
import {MuiPickersUtilsProvider,KeyboardTimePicker,KeyboardDatePicker,} from '@material-ui/pickers';
import Grid from '@material-ui/core/Grid';


export default function Dashboard__Table() {
  const [selectedDate, setSelectedDate] = React.useState(new Date('2014-08-18T21:11:54'));

  const handleDateChange = date => {
    setSelectedDate(date);
  };

  const theme = useTheme();
  const useStyles = makeStyles({
      card:{
          '@media (min-width : 600px)':{
             // width: 'calc(100% - 20px)',
          },
          '& td' : {
              //borderBottom : 'none',
              //padding:'0px 24px 0px 16px',
              fontSize: '12px',
          },
          '& th' : {
            //padding: '16px 16px 0px 16px',
          },
          '& tbody>tr:not(:last-child):nth-child(2n-1)':{
              //backgroundColor : '#604a0814',  
              //backgroundColor : 'rgb(247, 247, 247)',
              
          }
      },
  
    });

    return (
        <div>
           <TableContainer component={Paper}  elevation="0" className={useStyles().card}>
            <div className = "table-header-1">
         
         
            </div>
            <div className = "table-header-2">
                <Typography variant="body5" display="block" >
                 Most popular products
                </Typography>
            
            </div>
      <Table aria-label="simple table">
        <TableHead>
          <TableRow>
            
            <TableCell align="right">Product Name</TableCell>
            <TableCell align="right">Order Quantity</TableCell>
            <TableCell align="right">Category</TableCell>
            <TableCell align="right">Revenue</TableCell>
            
            
          </TableRow>
        </TableHead>
        <TableBody>
            <TableRow key="1">
            <TableCell align="right">
                Lahmacun
              </TableCell>
              <TableCell align="right">
                46
              </TableCell>
              <TableCell align="right">FOOD</TableCell>
              <TableCell align="right">3432 TL</TableCell>
          
            </TableRow>
        
            <TableRow key="2">
            <TableCell align="right">
                Efes Draft
              </TableCell>
              <TableCell align="right">
                43
              </TableCell>
              <TableCell align="right">DRINK</TableCell>
              <TableCell align="right">2300 TL</TableCell>
          
            </TableRow>
          
            <TableRow key="1">
            <TableCell align="right">
                Lahmacun
              </TableCell>
              <TableCell align="right">
                46
              </TableCell>
              <TableCell align="right">FOOD</TableCell>
              <TableCell align="right">3432 TL</TableCell>
          
            </TableRow>
        
            <TableRow key="2">
            <TableCell align="right">
                Efes Draft
              </TableCell>
              <TableCell align="right">
                43
              </TableCell>
              <TableCell align="right">DRINK</TableCell>
              <TableCell align="right">2300 TL</TableCell>
          
            </TableRow>
          
            <TableRow key="1">
            <TableCell align="right">
                Lahmacun
              </TableCell>
              <TableCell align="right">
                46
              </TableCell>
              <TableCell align="right">FOOD</TableCell>
              <TableCell align="right">3432 TL</TableCell>
          
            </TableRow>
        
            <TableRow key="2">
            <TableCell align="right">
                Efes Draft
              </TableCell>
              <TableCell align="right">
                43
              </TableCell>
              <TableCell align="right">DRINK</TableCell>
              <TableCell align="right">2300 TL</TableCell>
          
            </TableRow>
          

          
        </TableBody>
      </Table>
    </TableContainer>


        </div>
    );
}

